// Single source of truth for the running client's version. `deploy.sh` bumps it
// (npm version patch → synced here) BEFORE building, so each deployed bundle is
// stamped with its version. The `checkAppVersion` Cloud Function reports the
// latest version published to Firestore (appConfig/webClientVersion) after a
// deploy; when a user's running build is older, the VersionUpdateBanner offers
// a one-click refresh.
export const APP_VERSION = '0.1.30';

export const APP_CONFIG = {
  version: APP_VERSION,
  versionCheck: {
    // Master switch + banner toggle.
    autoCheck: true,
    showBanner: true,
    // Background re-check cadence (the hook also re-checks on focus / online).
    checkInterval: 5 * 60 * 1000, // 5 min
  },
} as const;
